export default "__VITE_ASSET__LK0R2haw__"